import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=54146bf5&scoped=true&"
import script from "./Region.vue?vue&type=script&lang=js&"
export * from "./Region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54146bf5",
  null
  
)

export default component.exports